(function () {
  'use strict';
  if (window.__flurB3G1) return;
  window.__flurB3G1 = true;

  var seq = 0;
  var applied = 0;
  var inflight = null;
  var lastCart = null;
  var offerObserver = null;
  var offerPaintQueued = false;
  var state = { count: 0, tier: null, next: null, maxed: false, appliedNow: false, savings: 0, estimate: 0, units: [], currency: 'USD' };

  /**
   * Config comes from snippets/flur-b3g1-config.liquid. Tiers are display and
   * fallback math only; the automatic discounts in admin are the money. The
   * offer discount is matched by title (one native discount per tier), plus
   * any legacy titles so a cart created under the old offer still reads right.
   */
  function cfg() {
    var el = document.querySelector('[data-b3g1-config]');
    if (!el) return { ids: {}, copy: {}, tiers: [], titles: {} };
    if (el.__parsed) return el.__parsed;
    var out = { ids: {}, copy: {}, tiers: [], titles: {} };
    try {
      var raw = JSON.parse(el.textContent);
      out.copy = raw.copy || {};
      out.familyDiscountTitle = raw.familyDiscountTitle;
      out.familyProductId = raw.familyProductId;
      out.tiers = (raw.tiers || []).map(function (t) {
        return { qty: Number(t.qty) || 0, pct: Number(t.pct) || 0, title: String(t.title || '') };
      }).filter(function (t) { return t.qty > 0 && t.pct > 0; }).sort(function (a, b) { return a.qty - b.qty; });
      out.tiers.forEach(function (t) { if (t.title) out.titles[t.title] = true; });
      out.countAll = !!raw.countAll;
      out.salePct = Number(raw.salePct) || 0;
      out.saleLabel = String(raw.saleLabel || '');
      out.freeShip = Number(raw.freeShip) || 0;
      out.shipCost = Number(raw.shipCost) || 0;
      (raw.legacyTitles || []).concat(raw.discountTitle ? [raw.discountTitle] : []).forEach(function (t) { if (t) out.titles[t] = true; });
      (raw.eligible || []).concat(raw.extraEligible || []).forEach(function (id) { if (id) out.ids[String(id)] = true; });
    } catch (e) {}
    el.__parsed = out;
    return out;
  }

  /** The app names its allocations "N Sets, X% Off"; accept that shape whatever the exact wording. */
  function isTierTitle(title) {
    if (!title) return false;
    if (cfg().titles[title]) return true;
    return /^\d+\s*sets?,\s*\d+\s*%\s*off$/i.test(String(title).trim());
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency || state.currency || 'USD',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function readCart() {
    if (inflight) return inflight;
    inflight = fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .finally(function () { inflight = null; });
    return inflight;
  }

  function groupedSections() {
    var ev = new Event('cart:grouped-sections', { bubbles: true });
    ev.detail = { sections: [] };
    document.dispatchEvent(ev);
    return (ev.detail.sections || []).filter(Boolean);
  }

  /**
   * Tell the theme the cart changed so the drawer contents, totals and count
   * refresh, while suppressing the drawer's auto-open: the brief requires the
   * builder to stay usable for the next selection.
   */
  function announce(cart, sections, allowOpen) {
    var muted = [];
    if (!allowOpen) {
      muted = Array.prototype.slice.call(document.querySelectorAll('cart-drawer-component[auto-open]'));
      muted.forEach(function (d) { d.removeAttribute('auto-open'); });
    }
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: cart,
      sourceId: 'flur-b3g1',
      data: { source: 'flur-b3g1', itemCount: cart ? cart.item_count : 0, isIncremental: false,
              sections: sections && Object.keys(sections).length ? sections : undefined }
    };
    document.dispatchEvent(ev);
    if (muted.length) setTimeout(function () { muted.forEach(function (d) { d.setAttribute('auto-open', ''); }); }, 0);
  }

  function offerText(key, values) {
    return (cfg().copy[key] || '').replace(/__([a-z_]+)__/g, function (_, name) {
      return values && values[name] !== undefined ? String(values[name]) : '';
    });
  }

  function compute(cart) {
    lastCart = cart;
    var config = cfg();
    state.hasFamilySet = (cart.items || []).some(function (item) {
      return String(item.product_id) === String(config.familyProductId);
    });
    var units = [], reported = 0, giftSavings = 0, lineSavings = 0, eligibleOriginal = 0;
    (cart.items || []).forEach(function (item) {
      var allAllocations = item.line_level_discount_allocations || item.discount_allocations || [];
      allAllocations.forEach(function (allocation) {
        var amount = Number(allocation.amount) || 0;
        lineSavings += amount;
        if (allocation.discount_application && allocation.discount_application.title === config.familyDiscountTitle) giftSavings += amount;
      });
      var unitPrice = item.original_price !== undefined ? item.original_price : item.price;
      var isGiftLine = !!(item.properties && item.properties._flur_family_gift) || unitPrice <= 0;
      var counts = config.countAll ? !isGiftLine : !!config.ids[String(item.product_id)];
      if (!counts) return;
      allAllocations.forEach(function (allocation) {
        var discount = allocation.discount_application || {};
        if (isTierTitle(discount.title)) reported += Number(allocation.amount) || 0;
      });
      var unit = item.original_price !== undefined ? item.original_price : item.price;
      eligibleOriginal += unit * item.quantity;
      for (var i = 0; i < item.quantity; i++) {
        units.push({ key: item.key, title: (item.product_title || '').replace(/^FLUR /, ''),
                     variantTitle: item.variant_title || '', price: unit, image: item.image });
      }
    });
    var tiers = config.tiers, tier = null, next = null;
    for (var t = 0; t < tiers.length; t++) {
      if (units.length >= tiers[t].qty) tier = tiers[t];
      else if (!next) next = tiers[t];
    }
    // When Shopify has applied a tier, its own title is the truth: "2 Sets, 15% Off" beats our count.
    var appliedPct = 0;
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || item.discount_allocations || []).forEach(function (allocation) {
        var d = allocation.discount_application || {};
        var m = isTierTitle(d.title) && /(\d+)\s*%/.exec(d.title);
        if (m && Number(allocation.amount) > 0) appliedPct = Math.max(appliedPct, Number(m[1]));
      });
    });
    if (appliedPct) {
      var hit = null;
      tiers.forEach(function (tt) { if (tt.pct === appliedPct) hit = tt; });
      if (hit) {
        tier = hit; next = null;
        tiers.forEach(function (tt) { if (tt.qty > hit.qty && !next) next = tt; });
      }
    }
    state.units = units;
    state.count = units.length;
    state.currency = cart.currency || 'USD';
    state.tiers = tiers;
    state.tier = tier;
    state.next = next;
    state.maxed = !!tier && !next;
    state.savings = reported;                                     // only what Shopify applied
    state.estimate = tier ? Math.round(eligibleOriginal * tier.pct / 100) : 0;
    state.giftSavings = giftSavings;
    state.otherSavings = Math.max(0, lineSavings - reported - giftSavings);
    // Order-level discounts (e.g. a sitewide automatic sale) never reach the line allocations.
    state.orderSavings = (cart.cart_level_discount_applications || []).reduce(function (sum, d) {
      return sum + (Number(d.total_allocated_amount) || 0);
    }, 0);
    state.appliedNow = reported > 0;
    state.confirmed = state.appliedNow;
    var cartTotal = cart.total_price !== undefined ? cart.total_price : (cart.items_subtotal_price || 0);
    // Gift cards and other non-shipping lines never count toward free shipping.
    var nonShipping = (cart.items || []).reduce(function (sum, it) { return it.requires_shipping === false ? sum + (Number(it.line_price) || 0) : sum; }, 0);
    state.subtotal = Math.max(0, cartTotal - nonShipping);
    state.original = cart.original_total_price || 0;
    return state;
  }

  function plural(n) { return n === 1 ? '' : 's'; }

  /** Card title: what the customer has unlocked. */
  function title() {
    if (!state.tier) return offerText('zero_title');
    return offerText('tier_title', { pct: state.tier.pct });
  }

  /** One line under the title: the next step, or the top-tier state. */
  /**
   * One line under the title. The landing card also carries a separate savings
   * line, so its top-tier message stays short; the drawer card has no savings
   * line and says the amount here.
   */
  function message(long) {
    if (!state.tier) {
      if (state.count > 0 && state.next) {
        var needZ = state.next.qty - state.count;
        return offerText('next', { need: needZ, plural: plural(needZ), next: state.next.pct });
      }
      return offerText('zero');
    }
    if (state.next) {
      var need = state.next.qty - state.count;
      return offerText('next', { need: need, plural: plural(need), next: state.next.pct });
    }
    if (long) return '';                       // drawer: at the top tier the bars say it all
    if (!state.appliedNow) return offerText('max_pending', { pct: state.tier.pct });
    return offerText('max_applied_short', { amount: money(state.savings), pct: state.tier.pct });
  }

  /** The tier one more set would land on: what a card's "Add set" is actually worth right now. */
  function nextPct() {
    var tiers = state.tiers || cfg().tiers || [], n = state.count + 1, pct = 0;
    tiers.forEach(function (t) { if (n >= t.qty) pct = t.pct; });
    // Sitewide sale (automatic discount): every eligible set shows the sale price.
    return Math.max(pct, Number(cfg().salePct) || 0);
  }

  function paintCardPrice(card) {
    var el = card.querySelector('[data-b3g1-card-price]');
    if (!el) return;
    var unit = parseInt(el.dataset.unit, 10) || 0;
    var pct = nextPct();
    el.textContent = money(Math.round(unit * (100 - pct) / 100));
    var was = card.querySelector('[data-b3g1-card-was]');
    if (was) { was.textContent = money(unit); was.hidden = !pct; }
  }

  function countLabel() {
    if (!state.tier) {
      if (state.count > 0) return offerText('count_pending', { count: state.count, plural: plural(state.count) }) || offerText('count_zero');
      return offerText('count_zero');
    }
    return offerText('count', { count: state.count, plural: plural(state.count), pct: state.tier.pct });
  }

  /** Segments and labels are rebuilt from the configured tiers. */
  function paintTiers(mod) {
    var tiers = state.tiers || [];
    var reached = state.tier ? tiers.indexOf(state.tier) + 1 : 0;
    mod.style.setProperty('--fb3-tiers', String(tiers.length || 3));
    var segs = mod.querySelector('[data-b3g1-segs]');
    if (segs) {
      while (segs.children.length < tiers.length) segs.appendChild(document.createElement('span'));
      while (segs.children.length > tiers.length) segs.removeChild(segs.lastChild);
      Array.prototype.forEach.call(segs.children, function (sp, i) { sp.classList.toggle('is-on', i < reached); });
    }
    var labs = mod.querySelector('[data-b3g1-labs]');
    if (labs) {
      labs.innerHTML = '';
      tiers.forEach(function (t, i) {
        var last = i === tiers.length - 1;
        var qtyText = last ? offerText('label_plus', { qty: t.qty })
                    : t.qty === 1 ? offerText('label_set', { qty: t.qty })
                    : offerText('label_sets', { qty: t.qty });
        var s = document.createElement('span');
        s.className = 'fb3-lab' + (i < reached ? ' is-on' : '');
        var b = document.createElement('b'); b.textContent = qtyText;
        s.appendChild(b);
        s.appendChild(document.createTextNode(offerText('label_pct', { pct: t.pct })));
        labs.appendChild(s);
      });
    }
  }

  function ctaLabel() {
    return state.count === 0 ? 'Choose sets' : 'View cart';
  }

  function paint() {
    var nativeTotals = document.querySelector('[data-b3g1-native-total]');
    if (lastCart && nativeTotals && Number(nativeTotals.dataset.b3g1NativeTotal) !== Number(lastCart.total_price)) return;
    if (offerObserver) offerObserver.disconnect();
    document.querySelectorAll('[data-b3g1-progress]').forEach(function (mod) {
      mod.classList.toggle('fb3-prog--on', !!state.tier);
      mod.classList.toggle('fb3-prog--win', state.maxed);

      var tt = mod.querySelector('[data-b3g1-title]');
      if (tt) tt.textContent = title();

      var tick = mod.querySelector('[data-b3g1-tick]');
      if (tick) tick.hidden = !state.maxed;

      var m = mod.querySelector('[data-b3g1-message]');
      if (m) m.textContent = message(false);

      var ml = mod.querySelector('[data-b3g1-message-long]');
      if (ml) { var mlt = message(true); ml.textContent = mlt; ml.hidden = !mlt; }

      var c = mod.querySelector('[data-b3g1-count]');
      if (c) c.textContent = state.tier ? countLabel() : title();

      paintTiers(mod);

      var sv = mod.querySelector('[data-b3g1-savings]');
      if (sv) {
        // Only a number Shopify actually applied; the message already says "at checkout" until then.
        var text = state.appliedNow ? offerText('savings', { amount: money(state.savings) }) : '';
        sv.textContent = text;
        sv.hidden = !text;
      }

      var thumbs = mod.querySelector('[data-b3g1-thumbs]');
      if (thumbs) {
        thumbs.innerHTML = '';
        state.units.forEach(function (u) {
          var label = u.title + (u.variantTitle ? ' · ' + u.variantTitle : '');
          var s = document.createElement('span');
          s.className = 'fb3-thumb';
          s.innerHTML = (u.image ? '<img src="' + u.image + '" alt="" loading="lazy">' : '') +
                        '<button type="button" class="fb3-thumb__x" data-b3g1-remove="' + u.key +
                        '" aria-label="Remove ' + label.replace(/"/g, '') + '">&times;</button>';
          s.title = label;
          thumbs.appendChild(s);
        });
      }

      var cta = mod.querySelector('[data-b3g1-cta]');
      if (cta) {
        var lbl = cta.querySelector('[data-b3g1-cta-label]') || cta;
        lbl.textContent = ctaLabel();
        cta.dataset.mode = state.count > 0 ? 'cart' : 'choose';
      }

      var live = mod.querySelector('[data-b3g1-live]');
      if (live) live.textContent = title() + ' ' + message(true);
      mod.dataset.b3g1State = state.maxed ? 'max' : String(state.count);

      // The one card lives in the "building" slot; the old success slot stays empty and hidden.
      var slot = mod.closest('[data-b3g1-slot]');
      if (slot) slot.hidden = state.hasFamilySet && state.count === 0;
    });

    document.querySelectorAll('[data-b3g1-card]').forEach(paintCardPrice);
    if (barEl) syncBar();
    paintShipping();
    paintTotals();
    observeOfferDOM();
  }

  function observeOfferDOM() {
    if (!document.body) return;
    if (!offerObserver) {
      offerObserver = new MutationObserver(function (records) {
        var selector = '[data-b3g1-progress], [data-b3g1-totals], [data-b3g1-ship], [data-b3g1-config], [data-b3g1-slot]';
        var relevant = records.some(function (record) {
          var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (target && target.closest(selector)) return true;
          return Array.prototype.some.call(record.addedNodes, function (node) {
            return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
          });
        });
        if (!relevant || offerPaintQueued || !lastCart) return;
        offerPaintQueued = true;
        requestAnimationFrame(function () {
          offerPaintQueued = false;
          compute(lastCart);
          paint();
        });
      });
    }
    offerObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'data-b3g1-state', 'data-b3g1-native-total'] });
  }

  function freeShipAt() { var v = Number(cfg().freeShip); return v > 0 ? v : 8900; }   // $89, on the discounted subtotal
  function shipCost() { var v = Number(cfg().shipCost); return v > 0 ? v : 695; }      // what free shipping saves ($6.95 flat rate since Oct 2026)
  function shipSaved() { return state.subtotal > 0 && state.subtotal >= freeShipAt() ? shipCost() : 0; }

  /** Free-shipping progress bar with a short label (bar added Sep 27 2026, Ethan preferred it to text only). */
  function paintShipping() {
    document.querySelectorAll('[data-b3g1-ship]').forEach(paintShipEl);
  }

  function paintShipEl(el) {
    var txt = el.querySelector('[data-b3g1-ship-text]');
    var fill = el.querySelector('[data-b3g1-ship-fill]');
    var remaining = freeShipAt() - state.subtotal;
    if (state.subtotal <= 0) { el.hidden = true; return; }
    el.hidden = false;
    if (fill) fill.style.width = Math.min(100, Math.round(state.subtotal / freeShipAt() * 100)) + '%';
    if (remaining <= 0) {
      el.classList.add('is-free');
      if (txt) txt.textContent = offerText('ship_free', { amount: money(shipCost()) }) || 'Your order ships free';
    } else {
      el.classList.remove('is-free');
      if (txt) txt.textContent = offerText('ship_away', { amount: money(remaining) }) || ("You're " + money(remaining) + ' away from free shipping');
    }
  }

  /** Items total / offer discount / subtotal, mirroring the cart mockup. */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /** Every discount on the cart, grouped by name, then free shipping when earned. */
  function itemizedRows() {
    var rows = [], at = {};
    function add(label, cents) {
      cents = Number(cents) || 0;
      if (cents <= 0) return;
      if (at[label] === undefined) { at[label] = rows.length; rows.push({ label: label, amount: 0 }); }
      rows[at[label]].amount += cents;
    }
    var cart = lastCart || {};
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        add((a.discount_application && a.discount_application.title) || 'Discount', a.amount);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      add(cfg().saleLabel || d.title || 'Discount', d.total_allocated_amount);
    });
    add('Free shipping', shipSaved());
    return rows;
  }

  function paintTotals() {
    document.querySelectorAll('[data-b3g1-totals]').forEach(function (wrap) {
      var discounts = state.savings + state.giftSavings + state.otherSavings;
      var ship = shipSaved();
      var total = discounts + ship;
      var set = function (sel, val) { var e = wrap.querySelector(sel); if (e) e.textContent = val; };
      // Cart drawer (Sep 28 2026): one "Total savings" line only, discounts plus free shipping once earned.
      if (wrap.closest('cart-drawer-component')) {
        // Itemized (Sep 29 2026): one row per discount, named after the sale, plus free shipping once earned.
        var rows = itemizedRows();
        wrap.hidden = rows.length === 0;
        var sumRowC = wrap.querySelector('[data-b3g1-total-savings-row]');
        if (sumRowC) sumRowC.hidden = true;
        var box = wrap.querySelector('[data-fb3-itemized]');
        if (!box) { box = document.createElement('div'); box.setAttribute('data-fb3-itemized', ''); box.className = 'fb3-itemized'; wrap.appendChild(box); }
        box.innerHTML = rows.map(function (r) {
          return '<div class="fb3-itemized__row"><span>' + esc(r.label) + '</span><span>\u2212' + money(r.amount) + '</span></div>';
        }).join('');
        return;
      }
      // Shipping alone is already said on the ship line; the block earns its place only with a product discount.
      wrap.hidden = !(discounts > 0);
      if (!(discounts > 0)) return;
      // Items total only earns its place when a discount row follows it.
      var itemsRow = wrap.querySelector('[data-b3g1-items-total]'); if (itemsRow && itemsRow.parentElement) itemsRow.parentElement.hidden = !(discounts > 0);
      var sumRow = wrap.querySelector('[data-b3g1-total-savings-row]');
      if (sumRow) {
        // Only when there is something to add up: two or more savings, never a restatement of one row.
        var parts = [state.savings, state.giftSavings, state.otherSavings, ship].filter(function (v) { return v > 0; }).length;
        sumRow.hidden = parts < 2;
        set('[data-b3g1-total-savings-label]', offerText(ship > 0 ? 'total_savings_ship' : 'total_savings') || 'Total savings');
        set('[data-b3g1-total-savings]', money(total));
      }
      set('[data-b3g1-items-total]', money(state.original));
      if (state.tier) set('[data-b3g1-offer-label]', offerText('totals_label', { pct: state.tier.pct }));
      [['b3g1-offer', state.savings], ['family-gift', state.giftSavings], ['other-discounts', state.otherSavings]].forEach(function (entry) {
        var row = wrap.querySelector('[data-' + entry[0] + '-row]');
        if (row) row.hidden = !entry[1];
        set('[data-' + entry[0] + '-amount]', '\u2212' + money(entry[1]));
      });
    });
  }

  function refresh() {
    var token = ++seq;
    return readCart().then(function (cart) {
      if (token < applied) return;       // never let a slow old response win
      applied = token;
      compute(cart);
      paint();
    }).catch(function () { /* keep last confirmed state */ });
  }

  function flash(btn, text) {
    if (!btn) return;
    var prev = btn.dataset.label || btn.textContent;
    btn.dataset.label = prev;
    btn.textContent = text;
    btn.classList.add('is-added');
    setTimeout(function () { btn.textContent = btn.dataset.label; btn.classList.remove('is-added'); }, 1800);
  }

  function errorOn(card, msg) {
    var el = card && card.querySelector('[data-b3g1-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    setTimeout(function () { el.hidden = true; }, 6000);
  }

  var busy = false;
  function addVariant(variantId, btn, card) {
    if (busy) return;                     // blocks rapid repeat taps
    busy = true;
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    var sections = groupedSections();
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sections.length) body.sections = sections.join(',');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'Could not add'); return d; }); })
      .then(function (d) {
        return readCart().then(function (cart) {
          announce(cart, d.sections, false);   // update everything, keep drawer shut
          compute(cart); paint();
          if (btn) { btn.disabled = false; flash(btn, 'Added'); }
        });
      })
      .catch(function (e) {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add set'; }
        errorOn(card, e.message || 'Could not add that set. Please try again.');
      })
      .finally(function () { busy = false; });
  }

  /** Decrement one unit of a specific cart line. */
  function removeOne(key, btn) {
    if (busy) return;
    busy = true;
    if (btn) btn.disabled = true;
    readCart()
      .then(function (cart) {
        var line = (cart.items || []).filter(function (i) { return i.key === key; })[0];
        var qty = line ? Math.max(0, line.quantity - 1) : 0;
        var sections = groupedSections();
        var body = { id: key, quantity: qty };
        if (sections.length) body.sections = sections.join(',');
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); });
      })
      .then(function (d) {
        return readCart().then(function (cart) {
          announce(cart, d && d.sections, false);
          compute(cart); paint();
        });
      })
      .catch(function () {
        var el = document.querySelector('[data-b3g1-error]');
        if (el) { el.textContent = 'Could not update the cart. Please try again.'; el.hidden = false; }
      })
      .finally(function () { busy = false; });
  }

  function selectSwatch(card, sw) {
    var img = card.querySelector('[data-b3g1-card-img]');
    var price = card.querySelector('[data-b3g1-card-price]');
    var add = card.querySelector('[data-b3g1-add]');
    var colour = card.querySelector('[data-b3g1-card-colour]');
    card.querySelectorAll('[data-b3g1-sw]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === sw)); });
    if (img && sw.dataset.img) { img.src = sw.dataset.img; }
    if (price) { price.dataset.unit = sw.dataset.price; paintCardPrice(card); }
    if (colour) colour.textContent = sw.dataset.title || '';
    var available = sw.dataset.available === 'true';
    if (add) {
      add.dataset.vid = sw.dataset.vid;
      add.disabled = !available;
      add.textContent = available ? 'Add set' : 'Sold out';
      add.dataset.label = add.textContent;
    }
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-b3g1-sw]');
    if (sw && !sw.disabled) { selectSwatch(sw.closest('[data-b3g1-card]'), sw); return; }

    var add = e.target.closest('[data-b3g1-add]');
    if (add && !add.disabled) {
      e.preventDefault();
      addVariant(add.dataset.vid, add, add.closest('[data-b3g1-card]'));
      return;
    }

    var rm = e.target.closest('[data-b3g1-remove]');
    if (rm) {
      e.preventDefault();
      removeOne(rm.getAttribute('data-b3g1-remove'), rm);
      return;
    }

    var cta = e.target.closest('[data-b3g1-cta]');
    if (cta) {
      e.preventDefault();
      if (cta.dataset.mode === 'cart') {
        // CartDrawerComponent extends DialogComponent: the method is showDialog().
        // There is no openDialog(), so guard against both and fall back to /cart.
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer) {
          if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return; }
          if (typeof drawer.open === 'function') { drawer.open(e); return; }
        }
        window.location.href = '/cart';
        return;
      }
      var builder = document.getElementById('b3g1-builder');
      if (builder) builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.location.href = '/pages/build-your-own-bundle';
    }
  });

  /**
   * Reveal the fixed bar once the in-page summary has scrolled out of view, so
   * progress and a route to the cart are always within reach.
   * Uses a rAF-throttled scroll check rather than IntersectionObserver: the
   * observer proved unreliable against the sticky sidebar on desktop.
   */
  var barEl = null, barAnchor = null, barTicking = false;

  function syncBar() {
    barTicking = false;
    if (!barEl || !barAnchor || !barAnchor.isConnected) return;
    // Anchor on the hero, not the summary card: the summary is position:sticky,
    // so its rect moves and the bar flickers. The hero never moves.
    // Only once there is something in the cart to view; an empty bar just points at the builder you are already on.
    var show = state.count > 0 && barAnchor.getBoundingClientRect().bottom < 0;
    barEl.classList.toggle('is-visible', show);
  }

  function onBarScroll() {
    if (barTicking) return;
    barTicking = true;
    requestAnimationFrame(syncBar);
  }

  function initStickyBar() {
    barEl = document.querySelector('[data-b3g1-bar]');
    if (!barEl) return;
    barAnchor = document.querySelector('.fb3h') || document.getElementById('b3g1-builder');
    barEl.hidden = false;
    if (!barEl.__bound) {
      barEl.__bound = true;
      window.addEventListener('scroll', onBarScroll, { passive: true });
      window.addEventListener('resize', onBarScroll, { passive: true });
      // This theme runs Lenis smooth scroll, which virtualises scrolling: native
      // scroll events (and IntersectionObserver) do not fire reliably on desktop.
      // Poll like the theme's own sticky header does.
      setInterval(syncBar, 120);
    }
    syncBar();
  }

  document.addEventListener('DOMContentLoaded', initStickyBar);
  window.addEventListener('load', initStickyBar);
  document.addEventListener('shopify:section:load', initStickyBar);

  // Reconcile after any cart change, wherever it came from.
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.data && e.detail.data.source === 'flur-b3g1') return;
    if (e.detail && e.detail.data && e.detail.data.source === 'flur-family-gift' && e.detail.resource) {
      applied = ++seq;
      compute(e.detail.resource);
      paint();
      return;
    }
    refresh();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();

/* Cart drawer trust footer: warranty tooltip (hover on desktop, tap on touch). Delegated at document
   level in capture phase because the drawer is re-rendered via innerHTML (inline scripts never run)
   and swallows bubbling clicks. */
(function () {
  if (window.__fctTipBound) return; window.__fctTipBound = true;
  function wrapOf(el) { return el && el.closest ? el.closest('[data-fct-tip-wrap]') : null; }
  function place(wrap) {
    var btn = wrap.querySelector('[data-fct-tip-btn]'), tip = wrap.querySelector('.flur-cart-trust__tip'); if (!btn || !tip) return;
    var b = btn.getBoundingClientRect(), t = tip.getBoundingClientRect();
    var x = (b.left + b.width / 2) - t.left; x = Math.max(16, Math.min(t.width - 16, x));
    tip.style.setProperty('--fct-arrow-x', x + 'px');
  }
  function set(wrap, open) {
    wrap.classList.toggle('is-open', open);
    var btn = wrap.querySelector('[data-fct-tip-btn]'); if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { place(wrap); requestAnimationFrame(function () { place(wrap); }); }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-fct-tip-btn]') : null;
    if (btn) { e.preventDefault(); e.stopPropagation(); var w = wrapOf(btn); set(w, !w.classList.contains('is-open')); return; }
    document.querySelectorAll('[data-fct-tip-wrap].is-open').forEach(function (w) { if (!w.contains(e.target)) set(w, false); });
  }, true);
  document.addEventListener('mouseover', function (e) { var w = wrapOf(e.target); if (w) place(w); }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('[data-fct-tip-wrap].is-open').forEach(function (w) { set(w, false); }); });
})();
